import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog']

  #trigger = null

  open(event) {
    this.#trigger = event.currentTarget
    this.dialogTarget.showModal()
  }

  requestClose(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }

  handleCancel() {}

  handleClose() {
    this.#trigger?.focus()
    this.#trigger = null
  }
}
